const staticPath = (relativePath: string) => {
  return window.location.href.indexOf("belimo.com") > -1
    ? `https://storage.googleapis.com/blm-hvac-quiz/prod${relativePath}`
    : relativePath
}

export default staticPath
